import type { iConfiguratorAccessory } from "../modules/Data/types";

export const hasValidSubGroupItems = (accessory: iConfiguratorAccessory) =>
  accessory.uiSubGroup &&
  Array.isArray(accessory.uiSubGroup.options) &&
  accessory.uiSubGroup.options.length > 0;
